<template>
  <div>
    <v-container>
      <v-form ref="form" v-model="valid" lazy-validation>
        <v-text-field v-model="email" :rules="emailRules" label="E-mail" required></v-text-field>

        <div v-if="ForgotPass==false">
        <v-text-field
          v-model="password"
          :append-icon="show1 ? 'visibility' : 'visibility_off'"
          :rules="passwordRules"
          :type="show1 ? 'text' : 'password'"
          name="input-10-1"
          label="Lösenord"
          counter
          required
          @click:append="show1 = !show1"
        ></v-text-field>
<div class="headline">Logga in som</div>
        <v-btn
          class="mt-2"
          dark
          :disabled="!valid"
          :loading="loading"
          color="success"
          @click="login"
        >
          <v-icon left>school</v-icon>Lärare
        </v-btn>
        <v-btn
          class="mt-2"
          dark
          :disabled="!valid"
          :loading="loading"
          color="blue"
          @click="loginEHT"
        >
          <v-icon left>volunteer_activism</v-icon>Elevhälsa
        </v-btn>
           <v-btn
          class="mt-2"
          dark
          :disabled="!valid"
          :loading="loading"
          color="error"
          @click="loginadmin"
        >
          <v-icon left>adb</v-icon>Admin
        </v-btn>
          <v-flex>
                   <p @click="ForgotPass=true">
Glömt lösenord?</p>
      </v-flex>
      Är du intresserad av att veta mer, kontakta info@ehtkollen.se
      </div>
      <div v-else>
      <v-flex xs12>
        <p>
           Är du admin och glömt ditt lösenord så kan du återställa här, är du lärare eller eht personal så be din admin att ge dig ett nytt lösenord, efter det kan du ändra det i inställningar.
      
        </p>
          <v-btn
          class="mt-2"
          depressed
          :disabled="!valid"
          :loading="loading"
          color="success"

          @click="ResetPassword"
        >
          <v-icon left>vpn_key</v-icon>
        Begär nytt lösenord!</v-btn>
      </v-flex>
            <v-flex>
                   <p @click="ForgotPass=false">

       Tillbaka</p>
      </v-flex>
      </div>
      </v-form>
       <!-- <Editorwindow Headline="Såhär arbetar EHT"  ToolColor="amber lighten-2" /> -->

     
  <!-- <Answers    v-model="dialog"  /> -->
<div class="Hidden" v-show="false">
      {{loggedInteacher}}
      {{loggedInmember}}
</div>
    </v-container>
  </div>
</template>

<script>
import { firebase } from '@/firebase'
import { mapActions, mapGetters } from 'vuex'

// import Editorwindow from '../../components/Arbetsatt/Editorwindow'
// import Answers from '../../components/Form/Answers'
export default { 
  //  components: {Answers,
  // },
  data: () => ({
    ForgotPass: false,
    dialog: true,
    show1: false,
    loading: false,
    valid: true,
    password: '',
    email: '',
    passwordRules: [v => !!v || 'Obligatoriskt fält'],
    emailRules: [
      v => !!v || 'Du måste fylla i E-mail',
      v => /.+@.+/.test(v) || 'Fel format'
    ]
  }),
    watch: {
        loggedInteacher: function (val) {
      if (this.loggedInteacher==true) {
                    this.loading = false
                  this.showSuccessSnackbar("Du är inloggad, välkommen "+this.teacher.name+"!")  
            this.$router.replace('/hometeacher')
      }
      else
      { 
      // this.showErrorSnackbar("Inloggning misslyckades, försök igen.")  
      }
    },
            loggedInmember: function (val) {
      
              //  (this.loggedInmember+"   "+val)

      if (this.loggedInmember==true) {
                  // this.showSuccessSnackbar("Du är inloggad, välkommen "+this.member.name+"!") 
                  this.showSuccessSnackbar("Du är inloggad, välkommen "+this.email+"!") 
                    this.loading = false;
                        //   (this.member)   
            this.$router.replace('/homeeht')
            // this.$router.push({ name: "HemEHT" });
      }
      else
      {
      this.showErrorSnackbar("Inloggning misslyckades, försök igen.")  
      }
    }
    },
  computed: {
    ...mapGetters('teachers', ['teacher','loggedInteacher']),
    ...mapGetters('ehtmembers', ['member','loggedInmember']),
  },
  methods: {
    
    ...mapActions('ehtmembers', ['loginmember','logoutEHT']),
    ...mapActions(['showSuccessSnackbar','showErrorSnackbar','showDelayErrorSnackbar']),
    ...mapActions('teachers', ['loginteacher','logoutTeacher']),
        loginEHT(){
          
      this.logoutEHT();
   this.loginmember([this.email, this.password]).then(res=>{
       if (res==null) {
       this.showDelayErrorSnackbar("Inloggning misslyckades, försök igen.")  
       }
     })
    },
    login(){
      this.logoutTeacher();
     this.loginteacher([this.email, this.password]).then(res=>{
       if (res==null) {
      this.showDelayErrorSnackbar("Inloggning misslyckades, försök igen.")
       }
     })

    },
    loginadmin () {
      if (this.$refs.form.validate()) {
        this.loading = true
        var auth = firebase.auth()
        auth.signInWithEmailAndPassword(this.email, this.password)
          .then(() => {
            this.loading = false
            this.$router.replace('/homeadmin')
             this.showSuccessSnackbar("Du är inloggad, välkommen admin!")
          })
          .catch(err => {
            this.loading = false
            
      this.showErrorSnackbar("Inloggning misslyckades, försök igen.")
            // const errorCode = err.code; handle per error code basis later
            // this.$store.dispatch("showErrorSnackbar", err.message);
            this.reset()
          })
      }
    },

    ResetPassword () {
      var auth = firebase.auth()
      let temp = this
      auth.sendPasswordResetEmail(this.email).then(function () {
             this.showSuccessSnackbar("Ett nytt lösenord har skickats till din mail.")
        //  temp.$store.dispatch(
        //             "showSuccessSnackbar",
        //             `Ett nytt lösenord har skickats till din mail.`
        //           );
        //  ('success')
        temp.ForgotPass = false
      }).catch(function (error) {
        //  (error)
      this.showErrorSnackbar("Något gick fel, försök igen.")

        //  ('Error' + error)
      })
    },
    reset () {
      this.$refs.form.reset()
    },
    resetValidation () {
      this.$refs.form.resetValidation()
    }
  }
}
</script>

<style>
</style>
